import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callme-title',
  templateUrl: './callme-title.component.html',
  styleUrls: ['./callme-title.component.scss']
})
export class CallmeTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
